// gameform.ts ↔ game/gameform.cpp — the pre-game STAGING room's shared
// constants + the roster helpers (kidfGameStart, forms.ini 1026). The canvas
// GameForm class was removed (canvas-removal R1); the DOM lobby drives staging
// now (dom/lobby-controller.ts, which reuses rosterFromPlayersUpdate /
// GetColorName / GetDisplayName / RosterEntry / the kfPlrr* wire flags).

import type { PlayerRecord } from '../../../protocol/gamemsg.ts';
import {
  kfPlrReady,
  kfPlrComputer,
  kfPlrUnfulfilled,
  kfPlrComputerOvermind,
  kfPlrCreator,
} from '../../../sim/src/player/side.ts';

export const kidfGameStart = 1026;
export const kidcGameName = 1001;
export const kidcMapName = 1002;
export const kidcNumPlayers = 1003;
export const kidcPlayerList = 1004;
export const kidcChat = 1904;
export const kidcAddBot = 1905;
export const kidcGameSpeedLabel = 1202;

// game/gameform.h:15-17
export const knGameStartResultDone = 0;
export const knGameStartResultFail = 1;
export const knGameStartResultStart = 2;

// mpshared/messages.h:35-40 (the extended game-join results)
export const knGameJoinResultRoomNotFound = 2;
export const knGameJoinResultGameNotFound = 3;
export const knGameJoinResultGameFull = 4;
export const knGameJoinResultInProgress = 5;

// mpshared/netmessage.h:232-238 — the WIRE PlayerRecord flags
export const kfPlrrReady = 0x01;
export const kfPlrrLocal = 0x02;
export const kfPlrrComputer = 0x04;
export const kfPlrrComputerOvermind = 0x08;
export const kfPlrrUnfulfilled = 0x10;
export const kfPlrrCreator = 0x20;
export const kfPlrrBot = 0x40;

/** A staged player — the C++ keeps these in the GLOBAL gplrm (PlayerMgr::Init
 *  over the PlayersUpdateNetMessage, Player.cpp:163-195); pre-game there is no
 *  Sim, so the TS form keeps the mapped records and Sim.create gets them as
 *  the roster. */
export interface RosterEntry {
  pid: number;
  side: number;
  name: string;
  flags: number; // kfPlr* (sim/src/player/side.ts), mapped per Player.cpp:163-195
  bot: boolean;
  local: boolean;
}

/** Player.cpp:163-195 — the kfPlrr* wire → kfPlr* game flag mapping. */
export function rosterFromPlayersUpdate(players: PlayerRecord[]): RosterEntry[] {
  return players.map((p) => ({
    pid: p.pid,
    side: p.side,
    name: p.name,
    flags:
      (p.wf & kfPlrrReady ? kfPlrReady : 0) |
      (p.wf & kfPlrrComputer ? kfPlrComputer : 0) |
      (p.wf & kfPlrrComputerOvermind ? kfPlrComputerOvermind : 0) |
      (p.wf & kfPlrrUnfulfilled ? kfPlrUnfulfilled : 0) |
      (p.wf & kfPlrrCreator ? kfPlrCreator : 0),
    bot: (p.wf & kfPlrrBot) !== 0,
    local: (p.wf & kfPlrrLocal) !== 0,
  }));
}

// gameform.cpp:188-202
export function GetColorName(side: number): string {
  switch (side) {
    case 0:
      return 'gray';
    case 1:
      return 'blue';
    case 2:
      return 'red';
    case 3:
      return 'yellow';
    case 4:
      return 'cyan';
  }
  return 'unknown';
}

/** A player's UI display name: AI/bot players (level-AI "AI" slots and added "Bot N"
 *  seats) show as "Apex" — the bot brain — while humans keep their name. `ai` is the
 *  caller's best AI/bot signal (computer flag and/or bot flag). The RAW name is still
 *  the identity key for join/leave/ready matching; only the shown text changes. */
export function GetDisplayName(name: string, ai: boolean): string {
  return ai ? 'Apex' : name;
}
